<template>
    <div>
        <div @click="back" class="flex items-center">
            <img class="arrow-back" src="@/assets/right_arrow.png" alt="">
            <p v-if="type == 'registration'" class="font-bold text-sm ml-2 text-additional-text">Текущая регистрация</p>
            <p v-if="type == 'database'" class="font-bold text-sm ml-2 text-additional-text">Все команды</p>
        </div>
        <div class="mt-6">
          <div class="flex justify-between relative">
         <h3>
             {{teamObject.name}}
         </h3>
         <img v-if="type=='registration' || (event && event.works_with_privileged)" @click.stop="openBox" src="@/assets/open-menu.png" alt="" class="menu-dots ">
         </div>

         <select-box v-if="type == 'registration' || type=='database' " placeholder="Без сортировки" class="text-menuOrder-dark-blue md:pr-5"
                     is_place no_padding fontIsNormal hideHeading  hideArrow positionBottomInfo
                     :listItems="options"
                     v-model="selected_filter"
                     ref="sortSelect">
         </select-box>
         <select-box placeholder="Без сортировки" class="text-menuOrder-dark-blue md:pr-5"
                     is_place no_padding fontIsNormal hideHeading  hideArrow
                     :listItems="options_stat"
                     v-model="selected_filter_stat"
                     ref="sortSelectStat">
         </select-box>

         <p class="text-additional-text mt-4 text-10px font-bold">
            Контактное лицо
         </p>
         <p class="font-bold text-sm mt-1">
             {{contactPerson.name}}
         </p>
         <p class="text-additional-text mt-4 text-10px font-bold">
             Номер телефона
         </p>
         <p class="font-bold text-sm mt-1">
              {{contactPerson.phone}}
         </p>
          <p class="text-additional-text mt-4 text-10px font-bold">
             E-mail
         </p>
         <p class="font-bold text-sm mt-1">
              {{contactPerson.email}}
         </p>
          <p v-if="playerCount" class="text-additional-text mt-4 text-10px font-bold">
             Кол-во игроков
         </p>
         <p v-if="playerCount" class="font-bold text-sm mt-1">
              {{playerCount}}
         </p>
          <p v-if="toString(totalCost) && type !=='database'" class="text-additional-text mt-4 text-10px font-bold">
             К оплате
         </p>
          <div v-if="toString(totalCost) && type !=='database'" class="relative">
            <div class="flex flex-row">
              <p  class="font-bold text-sm mt-1">
                {{totalCost}}
              </p>
              <img v-if="promocode_discount" @mouseover="switchPopper" @mouseleave="switchPopper" class="ml-1 z-10" src="@/assets/SVG/discount.svg" alt="" ref="discount">
            </div>
            <div class="absolute rounded-sm shadow-md p-2 bg-white mt-2 w-80" style="transform: translateX(2rem); z-index: 100;border: 0.5px solid #DADADA;" v-if="show_discount_popper" ref="elements">
              <p>Команда применила промокод на <br>  скидку -{{promocode_discount}}%</p>
            </div>
          </div>

          <p  class="text-additional-text mt-4 text-10px font-bold">
             Комментарий
         </p>
         <p class="font-bold text-sm mt-1">
              {{comment || '-'}}
         </p>
          <p v-if="play_count" class="text-additional-text mt-4 text-10px font-bold">
             Кол-во участий
         </p>
         <p v-if="play_count" class="font-bold text-sm mt-1">
              {{play_count}}
         </p>
          <div v-if="teamObject.company   && isCorpLeague">
          <p class="text-additional-text mt-4 text-10px font-bold">
            Название компании
         </p>
          <h4 v-if="teamObject.company   && isCorpLeague">
         {{teamObject.company.name}}
         </h4>
         </div>
         <div v-if="teamObject.company  && isCorpLeague" class="mt-1">
         <p class="text-additional-text mt-4 text-10px font-bold">
            Информация о компании
         </p>
         <h4 v-if="teamObject.company  && isCorpLeague" class="font-bold text-sm ">
             {{teamObject.company.description}}
         </h4>
         </div>
         <div v-if="images && Object.keys(images).length && isCorpLeague">
           <p class="text-additional-text mt-4 text-10px font-bold">Логотип</p>
           <div class="w-full flex items-center">
              <div v-for="image in images" :key="image" class="image-cont w-24 h-24 mr-4 " @click="downloadLogo(image)">
                   <img :src="image" class="image" >
               <div class="image-shadow"><img class="w-6 h-6" src="@/assets/SVG/download-data-white.svg" alt /></div>
              </div>
             </div>
          </div>
          <div v-if="false">
          <Networks v-if="this.contactPerson.social_networks" :networkRaw="this.contactPerson.social_networks" class="mt-4" />
          </div>
        <div class="divider mt-10"></div>
        <div class="flex mt-10" @click="deleteConfirm = true">
            <img class="w-3 h-3 md:w-auto md:h-auto " src="@/assets/SVG/trash-bin.svg">
            <p class="ml-2 text-10px md:text-sm underline">Удалить команду</p>
        </div>
        </div>

        <reg-modal v-if="deleteConfirm" @close="deleteConfirm = false">
            <p class="text-sm font-bold text-center mt-10">
                Вы уверены, что хотите удалить команду <span class="text-brand-light"> {{teamObject.name}}</span> ?
            </p>
            <div @click="deleteConfirm = false" class="button-reg-modal black-border mt-6">
             <p >Отменить</p>
            </div>
            <div @click="deleteLine" class="button-reg-modal mt-6 mb-10 yellow ">
            <p>Удалить</p>
            </div>
        </reg-modal>


         <reg-modal v-if="movingModal" @close="movingModal = false">
            <p class="text-sm font-bold text-center mt-10">
               Вы уверены, что хотите перенести команду в основной список?
            </p>
            <div @click="movingModal = false" class="button-reg-modal black-border mt-6">
             <p >Отменить</p>
            </div>
            <div @click="recoverLine" class="button-reg-modal mt-6 mb-10 yellow ">
            <p>Перенести</p>
            </div>
        </reg-modal>


        <reg-modal v-if="succesModal" @close="succesModal = false">
            <p class="text-sm font-bold text-center mt-10">
                Спасибо!
                <br>
                Данные успешно отправлены
            </p>
             <p class="text-sm mt-8 mb-3 text-center mt-10">
                По всем вопросам обращайтесь в службу поддержки
            </p>
        </reg-modal>

         <change-date-modal
              v-if="showDateChange"
              @close="showDateChange = false"
              :uuid="event.uuid"
              :record_id="event.event_record_id"
              :active_ids="[registrationId]"
              @change="dateChanged"
      ></change-date-modal>
    </div>
</template>
<script>
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';
import client from '@/clients/partners';
import regModal from './registration-modal.vue';
import ChangeDateModal from './changeDateModal';
import DeleteModal from '../../events/order/delete-modal';
import SelectBox from '../../selectbox';
import Networks from './network-templates';
import Popper from 'popper.js';

export default {
  name: 'info',
  props: ['teamObject', 'playerCount', 'totalCost', 'comment', 'event', 'play_count', 'type', 'registrationId', 'regType', 'creator', 'promocode_discount'],
  components: {
    ChangeDateModal, ConfirmDelete, DeleteModal, regModal, SelectBox, Networks,
  },
  data() {
    return {
      deleteConfirm: false,
      succesModal: false,
      showDateChange: false,
      movingModal: false,
      show_discount_popper: false,
      selected_filter: 5,
      selected_filter_stat: 4,
      contactPerson: {},
      options_stat: {
        0: { name: 'Присвоить льготную регистрацию', value: 'privileged' },
      },
      options: {
        0: { name: 'Удалить команду', value: 'delete' },
      },
    };
  },
  created() {
    if (this.regType === 'reserve') {
      this.options[2] = { name: 'Перенести в основной список', value: 'moveMain' };
    }
    if (this.creator && this.creator.id) {
      this.contactPerson = this.creator;
    } else {
      this.contactPerson = this.teamObject.captain;
    }
    this.getEventsForDateChange();
  },
  computed: {
    images() {
      if (this.teamObject.company) {
        return this.teamObject.company.media;
      }
      return null;
    },
    isCorpLeague() {
      return this.event.product.toLowerCase().includes('корпоративная лига');
    },

  },

  methods: {
    getEventsForDateChange() {
      /*  проверяем можно ли перенести и добавляем опшн */
      client.get('/event-dates')
        .then((response) => {
          this.events = response.data;
          const eventDates = [];
          for (const i in this.events) {
            for (const j in this.events[i]) {
              eventDates.push(this.events[i][j]);
            }
          }
          if ((eventDates.filter(item => item.event_record_id === this.event.event_record_id && item.uuid !== this.event.uuid && item.status !== 'waiting_statistics').length)) {
            this.options[1] = { name: 'Перенести на другой день', value: 'changeDate' };
          }
        });
    },
    openBox() {
      if (this.type != 'stat') {
        this.$refs.sortSelect.openBox();
      } else {
        this.$refs.sortSelectStat.openBox();
      }
    },
    toggleDateChange() {
      this.showDateChange = true;
    },
    back() {
      this.$router.go(-1);
    },
    confirmDelete() {
      this.deleteConfirm = true;
    },
    deleteLine() {
      if (this.type == 'registration') {
        client.delete(`/applications/dates/${this.event.uuid}`, {
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            applications_ids: [this.registrationId],
          },
        }).then(() => {
          this.succesModal = true;
          this.$router.push('/partners/registration');
        }).finally(() => this.deleteConfirm = false);
      } else if (
        this.type == 'database'
      ) {
        let link;
        link = `/teams?ids[]=${[this.teamObject.id]}`;
        client.delete(link).then(() => {
          this.succesModal = true;
          this.deleteConfirm = false;
        });
      }
    },
    recoverLine() {
      client
        .patch(`/applications/dates/${this.event.uuid}`, {
          applications_ids: [this.registrationId],
          status: 'active',
        })
        .then(() => {
          this.succesModal = true;
        }).finally(() => this.movingModal = false);
    },
    privileged() {
      client.post(`/applications/${this.registrationId}`);
    },
    dateChanged() {
      this.showDateChange = false;
      this.succesModal = true;
    },
    switchPopper() {
      this.show_discount_popper = !this.show_discount_popper;
      if (this.show_discount_popper) {
        this.$nextTick(() => {
          this.setupPopper();
        });
      }
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.$refs.discount, this.$refs.elements, {
          placement: 'bottom-end',
        });
      } else {
        this.popper.scheduleUpdate();
      }
    },
  },
  watch: {
    selected_filter() {
      if (this.selected_filter == 0) {
        this.deleteConfirm = true;
      } else if (this.selected_filter == 1) {
        this.toggleDateChange();
      } else if (this.selected_filter == 2) {
        this.movingModal = true;
      } else if (this.selected_filter == 3) {

      }
    },
    selected_filter_stat() {
      if (this.selected_filter_stat == 0) {
        this.privileged();
      }
    },
  },
};
</script>
<style  scoped>
.arrow-back {
transform: rotate(180deg);
height: 15px;
}
.divider {
    width: 85%;
    margin-left: auto;
    margin-right: auto;
    height: 1px;
    background-color: #979797
  }
  .button-reg-modal {
      width: 90%;
      margin-right: 20px;
      margin-left: 20px;
     height: 40px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 45px;
      font-weight: bold;
      font-size: 14px;
  }
  .yellow {
      background-color:  #FFCE42;
  }
  .black-border {
 border: 1px solid black;
  }
  .menu-dots {
    position: absolute;
    right: -10px;
    top: -10px;
    padding: 10px;
  }
  .network-object {
    border: 1px solid #DADADA;
    border-radius: 3px;
    background: rgba(74, 0, 69, 0.05);
    color: #4A0045;
  }
</style>
